<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('global.language_update_title') }}</span>
            <span v-else>{{ $t('global.language_create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-row>
          <b-col cols="12" md="4">
            <b-form-group>
              <label>{{ $t('global.languages_name') }}</label>
              <b-form-input type="text" :placeholder="$t('global.languages_name_placeholder') "
                :class="{ 'is-invalid' : errorMsg.name }"
                v-model="entity.name"/>
              <div class="invalid-feedback" v-if="errorMsg.name">{{ errorMsg.name[0] }}</div>
            </b-form-group>
            <b-form-group>
              <label>{{ $t('global.language_key') }}</label>
              <b-form-input type="text" :placeholder="$t('global.language_key_placeholder')"
                :class="{ 'is-invalid' : errorMsg.key }"
                v-model="entity.key"/>
              <div class="invalid-feedback" v-if="errorMsg.key">{{ errorMsg.key[0] }}</div>
            </b-form-group>
            <b-form-group>
              <label>{{ $t('global.is_active') }}</label>
              <b-form-checkbox
                :class="{ 'is-invalid' : errorMsg.is_active }"
                v-model="entity.is_active"/>
              <div class="invalid-feedback" v-if="errorMsg.is_active">{{ errorMsg.is_active[0] }}</div>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'Languages' }" >
          <b-button type="reset" variant="info" class="ml-2">{{ $t('global.cancel') }}</b-button>
        </router-view>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VT from '@/store/types';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: true,
        isSaving: false,
      },
      entity: { // Entity being edited or created
        name: '',
        key: '',
        is_active: true
      },
      errorMsg: {}
    };
  },
  props: {
    id: {
      type: Number,
      default: null // If create form prop will be null, because route contains no id
    },
  },
  components: {
  },
  computed: {
    isUpdateForm() {
      return this.id !== null;
    }
  },
  methods: {
    ...mapActions('Languages', {
      getForUpdate: VT.LANGUAGE_UPDATE_DATA,
      getForCreate: VT.LANGUAGE_CREATE_DATA,
      pushUpdate: VT.LANGUAGE_UPDATE,
      pushCreate: VT.LANGUAGE_CREATE,
    }),
    load() {
      const action = this.isUpdateForm ? this.getForUpdate : this.getForCreate;
      action(this.$route.params.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.language : { ...this.entity, ...data.data.language };
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data.errors;
      });
    },
    save() {
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? this.pushUpdate : this.pushCreate;
      action(this.entity).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        this.entity = data.data;
        if (!this.isUpdateForm) {
          this.$router.push({ name: 'LanguageUpdate', params: { id: data.data.id } });
        }
      }).catch((data) => {
        this.spinners.isSaving = false;
        this.errorMsg = data.data.data.errors;
        this.alertError();
      });
    },
  }
};
</script>

<style scoped>
</style>
